import React, { useState, useEffect } from 'react';
import { FormGroup, FormLabel } from 'react-bootstrap';
import styled from 'styled-components';
import { useTheme } from 'styled-components';

interface ToggleSwitchProps {
  value?: 'S' | 'N' | null; // Adicionando o estado neutro como null
  onChange?: (value: 'S' | 'N') => void; // Não permitimos null após o primeiro clique
  label: string;
}

const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  flex-direction: row;
  margin-top: 0.6vh;
`;

const SwitchLabel = styled.span`
  margin-left: 10px;
  font-size: 14px;
`;

const Switch = styled.div<{ active: boolean | null }>`
  width: 50px;
  height: 25px;
  border-radius: 25px;
  background-color: ${({ active }) =>
    active === true ? '#a6e29e' : active === false ? '#c5c5c5' : '#e0e0e0'};
  position: relative;
  transition: background-color 0.3s ease-in-out;
`;

const SwitchHandle = styled.div<{ active: boolean | null }>`
  width: 23px;
  height: 23px;
  border-radius: 50%;
  background-color: ${({ active, theme }) =>
    active === true
      ? theme.colors.verdegov
      : active === false
        ? '#535353'
        : '#bdbdbd'};
  position: absolute;
  top: 1px;
  left: ${({ active }) =>
    active === true ? '26px' : active === false ? '1px' : '13px'};
  transition: left 0.3s ease-in-out;
`;

export default function ToggleSwitch({
  value = null,
  onChange,
  label,
}: ToggleSwitchProps) {
  const theme = useTheme();
  const [active, setActive] = useState<boolean | null>(
    value === 'S' ? true : value === 'N' ? false : null,
  );

  useEffect(() => {
    setActive(value === 'S' ? true : value === 'N' ? false : null);
  }, [value]);

  const handleClick = () => {
    let newValue: 'S' | 'N';

    if (active === null) {
      // Se o estado for neutro, mova para o primeiro valor 'S'
      newValue = 'S';
    } else if (active === true) {
      // Se estiver ativo ('S'), mude para 'N'
      newValue = 'N';
    } else {
      // Se estiver inativo ('N'), mude para 'S'
      newValue = 'S';
    }

    setActive(newValue === 'S');
    if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <FormGroup>
      <FormLabel style={{ color: theme.colors.textoAzul }}>{label}</FormLabel>
      <SwitchContainer onClick={handleClick}>
        <Switch active={active}>
          <SwitchHandle active={active} />
        </Switch>
        <SwitchLabel>
          {active === true ? 'Sim' : active === false ? 'Não' : ''}
        </SwitchLabel>
      </SwitchContainer>
    </FormGroup>
  );
}
